import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Account } from '../../models/account';
import { pickBy } from 'lodash';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AccountsService {
    constructor(private http: HttpClient) {}

    public searchAccounts(searchTerm: string, limit: number, nftId?: string) {
        const httpParams = new HttpParams({ fromObject: { searchTerm, limit, nftId } });
        return this.http.get(`${environment.api_url}/accounts`, { params: httpParams });
    }

    public getPaginatedAccounts(pageSize: number, pageNumber: number, sortBy: string, accountId: string) {
        const httpParams = new HttpParams({
            fromObject: pickBy({ pageSize, pageNumber, sortBy, accountId }, (v) => v !== undefined),
        });
        return this.http.get(`${environment.api_url}/accounts/paginated`, { params: httpParams });
    }

    public getAccount(accountId: string) {
        return this.http.get(`${environment.api_url}/accounts/${accountId}`);
    }

    public updateAccount(accountId: string, account: Account) {
        return this.http.put(`${environment.api_url}/accounts/${accountId}`, { account });
    }

    public enableAccount(accountId: string) {
        return this.http.put(`${environment.api_url}/accounts/enable/${accountId}`, {});
    }

    validateUsername(username: string) {
        return this.http.post<{ isValid: boolean }>(`${environment.api_url}/auth/validate/username`, { username });
    }

    public downloadAccountsCsv(fields: string[]): Observable<HttpResponse<Blob>> {
        return this.http.post(
            `${environment.api_url}/accounts/export`,
            { fields },
            { observe: 'response', responseType: 'blob' }
        );
    }

    public removeKyc(userId: string, reason: string) {
        return this.http.post(`${environment.api_url}/accounts/delete-kyc`, { userId, reason });
    }
}
